export default function createPropsForXocsArticle(xocsArticle) {
  const {
    authors: authorsString,
    doi,
    page: pageString,
    pdfPath,
    pii,
    publicationDate,
    publicationTitle: publicationName,
    articleTitle: title,
    docSubType: documentSubtype,
  } = xocsArticle;

  const authors = authorsString.split(',');

  const pageRange = pageString
    ? pageString.split('-')
    : [];

  return {
    authors,
    doi,
    pageRange,
    pdfPath,
    pii,
    publicationDate,
    publicationName,
    title,
    documentSubtype,
  };
}
